<template>
    <div cds-layout="vertical" style="height: 100%">

      <div cds-layout="horizontal gap:md align:left" class="header">
        <div>
          <router-link to="/" >
            <img class="logo" src="@/assets/factset.svg">
          </router-link> 
        </div>   
      </div>
  
      <div cds-layout="align:stretch" class="router">
        <router-view/>
      </div>

      <div cds-layout="horizontal gap:md align:left" class="footer">
        <span style="color: white;">
          Copyright © 2023 FactSet | 
        </span>
        <span>
          <a href="https://go.factset.com/legal" >
            <cds-button style="padding-top: 7px;" action="flat-inline">Privacy & Legal</cds-button>
          </a>
        </span>
      </div>
    </div>
</template>

<style lang="scss">

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.logo {
  min-height: 5%;
  max-height: 5%;
  padding-top: 9px;
}

.header {
  height: 5%; 
  min-height: 5%;
  max-height: 5%;
  background-color: #101a2a;
  width: 100%; 
}

.router {
  width: 100%;
}

.footer {
  height: 5%; 
  min-height: 5%;
  max-height: 5%;
  background-color: #101a2a; 
  padding: 6px;
  padding-left: 10px
}

</style>
